module.exports = __webpack_public_path__ + "img/developer.0bb5ee47.png";